import React from "react";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { useEntityHandlerContext } from "../../../controllers/entityController";
import { RichTextEditor } from "../../field/richTextEditor/RichTextEditor";

interface ViewRichTextFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  maxLines?: number;
}

const ViewRichTextField: React.FC<ViewRichTextFieldProps> = ({
  name,
  label,
  placeholder = "N/A",
  maxLines,
}) => {
  const { methods } = useEntityHandlerContext();
  const data = methods.getValues();
  const rawValue = data?.[name as keyof typeof data];
  const value = typeof rawValue === "string" ? rawValue : "";

  return (
    <Grid size={{ xs: 12 }}>
      <Box sx={{ mb: 2 }}>
        {label ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 0.5 }}
          >
            {label}
          </Typography>
        ) : null}
        <RichTextEditor
          value={value}
          readOnly
          fullWidth
          maxLines={maxLines}
          placeholder={placeholder}
        />
      </Box>
    </Grid>
  );
};

export default ViewRichTextField;
